import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "log-container fill-height overflow-y-auto pb-8" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AssistantsView = _resolveComponent("AssistantsView")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_AutomationsView = _resolveComponent("AutomationsView")!
  const _component_DashboardChat = _resolveComponent("DashboardChat")!
  const _component_Providers = _resolveComponent("Providers")!
  const _component_Mcp = _resolveComponent("Mcp")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_Models = _resolveComponent("Models")!
  const _component_Agents = _resolveComponent("Agents")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Factories = _resolveComponent("Factories")!
  const _component_Schedules = _resolveComponent("Schedules")!
  const _component_Embeddings = _resolveComponent("Embeddings")!
  const _component_PromptStudio = _resolveComponent("PromptStudio")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_vue_json_pretty = _resolveComponent("vue-json-pretty")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_SlideAside = _resolveComponent("SlideAside")!
  const _component_AgentWizardDialog = _resolveComponent("AgentWizardDialog")!
  const _component_ConfigurationChatDialog = _resolveComponent("ConfigurationChatDialog")!
  const _component_UserModeDialog = _resolveComponent("UserModeDialog")!
  const _component_SimpleUiAnnouncementDialog = _resolveComponent("SimpleUiAnnouncementDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.authenticated)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "dashboard-container pa-0",
        app: "",
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SlideAside, {
            modelValue: _ctx.logVisible,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.logVisible) = $event)),
            width: 500
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                density: "compact",
                class: "ma-0 pa-0 fill-height dashboard-main-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "ma-0 py-0 pl-0 pr-4 fill-height dashboard-main-col"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.userMode === 'simple')
                        ? (_openBlock(), _createBlock(_component_v_window, {
                            key: 0,
                            modelValue: _ctx.tab,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
                            class: "tab-windows fill-height"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_window_item, {
                                value: "assistants",
                                class: "mr-4 ml-8 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_AssistantsView)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "automations",
                                class: "mr-4 ml-8 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_AutomationsView)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "chat",
                                class: "my-0 mt-4 fill-height"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DashboardChat)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "providers",
                                class: "mr-4 ml-8 mt-4 fill-height"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Providers)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "mcp",
                                class: "mr-4 ml-8 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Mcp)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(_component_v_window, {
                            key: 1,
                            modelValue: _ctx.tab,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
                            class: "tab-windows fill-height"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_window_item, {
                                value: "providers",
                                class: "mr-4 ml-8 mt-4 fill-height"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Providers)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "models",
                                class: "mr-4 ml-8 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Models)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "agents",
                                class: "mr-4 ml-8 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Agents)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "workflows",
                                class: "mr-4 mt-4 fill-height dashboard-workflows-pane"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.tab === 'workflows')
                                    ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "factories",
                                class: "mr-4 mt-4 fill-height dashboard-workflows-pane"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Factories)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "pages",
                                class: "mr-4 ml-8 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.tab === 'pages')
                                    ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "schedules",
                                class: "mr-4 ml-8 mt-4 fill-height"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Schedules)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "embeddings",
                                class: "mr-4 ml-8 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Embeddings)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "studio",
                                class: "my-4 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_PromptStudio)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "chat",
                                class: "my-0 mt-4 fill-height"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DashboardChat)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, {
                                value: "mcp",
                                class: "mr-4 ml-8 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Mcp)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            right: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("header", { class: "log-header text-h6 px-4 pt-4 pb-0" }, "Event log", -1)),
                _createVNode(_component_v_list, {
                  density: "compact",
                  class: "log-list"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (e) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: e.id,
                        class: "log-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "log-title" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(e.title), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (e.content != null)
                            ? (_openBlock(), _createBlock(_component_v_list_item_content, {
                                key: 0,
                                class: "log-text"
                              }, {
                                default: _withCtx(() => [
                                  (typeof e.content === 'string')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(e.content), 1))
                                    : (_openBlock(), _createBlock(_component_vue_json_pretty, {
                                        key: 1,
                                        data: e.content,
                                        deep: "2",
                                        theme: "dark"
                                      }, null, 8, ["data"]))
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                _cache[4] || (_cache[4] = _createElementVNode("span", { id: "bottom" }, null, -1))
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_AgentWizardDialog),
          _createVNode(_component_ConfigurationChatDialog),
          _createVNode(_component_UserModeDialog, { ready: _ctx.initialDataLoaded }, null, 8, ["ready"]),
          _createVNode(_component_SimpleUiAnnouncementDialog, { eligible: _ctx.announceSimpleUi }, null, 8, ["eligible"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}